<div class="customer-order-view wrapper-content">
  <app-linker-route
    [headingName]="headingName"
    [linkerRouteItems]="linkerRouteItems"
  ></app-linker-route>

 

  <section class="order-hero">
    <div class="order-hero__cover"></div>
    <div class="order-hero__content">
      <div class="order-hero__left">
        <p class="order-hero__eyebrow">Customer Order</p>
        <h1 class="order-hero__title">Order {{ orderDataDetials?.orderId || '--' }}</h1>

 

        <div class="order-pill-group">
          <span class="order-pill">
            <label>Placed On</label>
            <strong>{{ orderDataDetials?.createdAt | date : 'mediumDate' }}</strong>
          </span>
          <span class="order-pill" *ngIf="viewOrderData?.length">
            <label>Items</label>
            <strong>{{ viewOrderData.length }}</strong>
          </span>
          <span class="order-pill" *ngIf="orderDataDetials?.orderPrice">
            <label>Order Value</label>
            <strong>
              {{
                getPrice(orderDataDetials?.orderPrice | currency : 'ZAR' : 'R')
              }}
            </strong>
          </span>
          <span class="order-pill" *ngIf="orderDataDetials?.paymentStatus">
            <label>Payment Status</label>
            <strong>{{ orderDataDetials?.paymentStatus }}</strong>
          </span>
          <span class="order-pill" *ngIf="orderDataDetials?.deliveryStatus">
            <label>Delivery Status</label>
            <strong>{{ orderDataDetials?.deliveryStatus }}</strong>
          </span>
        </div>
      </div>

 

      <div class="order-hero__actions">
        <button
          class="hero-action-btn"
          (click)="getpdf()"
          [disabled]="!isInvoiceDisable"
        >
          Download Invoice
        </button>
      </div>
    </div>
  </section>

 

  <section class="order-grid">
    <!-- Product Details -->
    <article class="order-card product-card">
      <div class="section-header">
        <p class="section-eyebrow">Products</p>
        <h2>Items in this order</h2>
      </div>

 

      <div class="product-list" *ngIf="viewOrderData?.length; else noProduct">
        <div class="product-item" *ngFor="let item of viewOrderData">
          <div class="product-thumb">
            <img
              [src]="item?.productId?.thumbnail"
              [hidden]="!item?.isLoaded"
              (load)="onLoadImage(item)"
              alt="{{ item?.productId?.productName || 'product image' }}"
            />
            <ngx-skeleton-loader
              *ngIf="!item?.isLoaded"
              count="1"
              [theme]="{ width: '100%', height: '110px' }"
            ></ngx-skeleton-loader>
          </div>
          <div class="product-info">
            <div class="product-head">
              <h3>{{ item?.productId?.productName || '--' }}</h3>
              <span class="price-chip">
                {{
                  item?.priceSizeDetails?.price
                    ? getPrice(item?.priceSizeDetails?.price | currency : 'ZAR' : 'R')
                    : getPrice(item?.price | currency : 'ZAR' : 'R')
                }}
              </span>
            </div>

 

            <div class="product-meta-grid">
              <div class="meta-item">
                <span class="meta-label">Quantity</span>
                <span class="meta-value">{{ item?.quantity || '--' }}</span>
              </div>
              <div class="meta-item">
                <span class="meta-label">Value / Size</span>
                <span class="meta-value">
                  {{ item?.priceSizeDetails?.value || '--' }}
                  <span *ngIf="item?.priceSizeDetails?.unit">
                    - {{ item?.priceSizeDetails?.unit }}
                  </span>
                </span>
              </div>
              <div class="meta-item">
                <span class="meta-label">Product ID</span>
                <span class="meta-value">{{ item?._id || '--' }}</span>
              </div>
              <div class="meta-item">
                <span class="meta-label">Expected delivery</span>
                <span class="meta-value">
                  <ng-container [ngSwitch]="orderDataDetials?.deliveryType">
                    <span *ngSwitchCase="'STANDARD'">
                      {{ getAddedDate(orderDataDetials?.createdAt, 7) | date : 'mediumDate' }}
                    </span>
                    <span *ngSwitchCase="'SAMEDAY'">
                      {{ getNextDayOrSameDay(orderDataDetials?.createdAt) | date : 'mediumDate' }}
                    </span>
                    <span *ngSwitchCase="'BUSINESSDAY'">
                      {{ getNextBusinessDayFromDate(orderDataDetials?.createdAt) | date : 'mediumDate' }}
                    </span>
                    <span *ngSwitchCase="'SATURDAY'">
                      {{ getNextSaturdayFromDate(orderDataDetials?.createdAt) | date : 'mediumDate' }}
                    </span>
                    <span *ngSwitchCase="'SUNDAY'">
                      {{ getSundayDate(orderDataDetials?.createdAt) | date : 'mediumDate' }}
                    </span>
                    <span *ngSwitchDefault>--</span>
                  </ng-container>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ng-template #noProduct>
        <div class="empty-state">
          <p>No product details available.</p>
        </div>
      </ng-template>
    </article>

 

    <!-- Shipping Details -->
    <article class="order-card shipping-card">
      <div class="section-header">
        <p class="section-eyebrow">Deliver To</p>
        <h2>Shipping Address</h2>
      </div>

 

      <ng-container *ngIf="orderDataDetials?.shippingAddress; else noAddress">
        <div class="shipping-details">
          <h3>
            {{ orderDataDetials?.shippingAddress?.firstName }}
            {{ orderDataDetials?.shippingAddress?.lastName }}
          </h3>
          <p class="text-muted">
            {{ orderDataDetials?.shippingAddress?.email || 'Email not provided' }}
          </p>

 

          <div class="detail-block">
            <label>Address</label>
            <p>
              {{ orderDataDetials?.shippingAddress?.address }}
              {{ orderDataDetials?.shippingAddress?.addressLine1 }}
              {{ orderDataDetials?.shippingAddress?.addressLine2 }}
            </p>
            <p>
              {{ orderDataDetials?.shippingAddress?.city }},
              {{ orderDataDetials?.shippingAddress?.state }},
              {{ orderDataDetials?.shippingAddress?.country }},
              {{ orderDataDetials?.shippingAddress?.zipCode }}
            </p>
          </div>

 

          <div class="detail-block" *ngIf="orderDataDetials?.shippingAddress?.mobileNumber">
            <label>Phone</label>
            <p>
              {{ orderDataDetials?.shippingAddress?.countryCode | phoneFormat }} -
              {{ orderDataDetials?.shippingAddress?.mobileNumber | phoneFormat }}
            </p>
          </div>

 

          <div
            class="detail-block"
            *ngIf="orderDataDetials?.shippingAddress?.location?.coordinates?.length === 2"
          >
            <a
              class="link-inline"
              [href]="
                'https://www.google.com/maps/@' +
                orderDataDetials?.shippingAddress?.location?.coordinates[1] +
                ',' +
                orderDataDetials?.shippingAddress?.location?.coordinates[0] +
                ',14z'
              "
              target="_blank"
              rel="noopener noreferrer"
            >
              View on map
            </a>
          </div>
        </div>
      </ng-container>
      <ng-template #noAddress>
        <div class="empty-state">
          <p>No shipping address available.</p>
        </div>
      </ng-template>
    </article>

 

    <!-- Payment Details -->
    <article class="order-card payment-card">
      <div class="section-header">
        <p class="section-eyebrow">Payment</p>
        <h2>Transaction Summary</h2>
      </div>

 

      <ul class="payment-list">
        <li>
          <span>Subtotal</span>
          <strong>
            {{
              orderDataDetials?.actualPrice
                ? getPrice(orderDataDetials?.actualPrice | currency : 'ZAR' : 'R')
                : '--'
            }}
          </strong>
        </li>
        <li>
          <span>Delivery Fee</span>
          <strong>
            {{
              orderDataDetials?.deliveryFee
                ? getPrice(orderDataDetials?.deliveryFee | currency : 'ZAR' : 'R')
                : 'Free'
            }}
          </strong>
        </li>
        <li>
          <span>VAT @ 15%</span>
          <strong>
            {{
              orderDataDetials?.actualPrice
                ? getPrice(
                    (orderDataDetials?.actualPrice / 100) * 15 | currency : 'ZAR' : 'R'
                  )
                : '--'
            }}
          </strong>
        </li>
        <li class="total-row">
          <span>Grand Total</span>
          <strong>
            {{
              orderDataDetials?.orderPrice
                ? getPrice(orderDataDetials?.orderPrice | currency : 'ZAR' : 'R')
                : '--'
            }}
          </strong>
        </li>
        <li>
          <span>Delivery Status</span>
          <strong
            [ngClass]="
              orderDataDetials?.deliveryStatus === 'PENDING'
                ? 'text-status-warning'
                : 'text-status-success'
            "
          >
            {{ orderDataDetials?.deliveryStatus || '--' }}
          </strong>
        </li>
        <li>
          <span>Payment Status</span>
          <strong
            [ngClass]="{
              'text-status-success':
                orderDataDetials?.paymentStatus === 'COMPLETED' ||
                orderDataDetials?.paymentStatus === 'RETURN APPROVED',
              'text-status-warning':
                orderDataDetials?.paymentStatus === 'PENDING' ||
                orderDataDetials?.paymentStatus === 'RETURN REQUESTED' ||
                orderDataDetials?.paymentStatus === 'RETURN DECLINED'
            }"
          >
            {{ orderDataDetials?.paymentStatus || '--' }}
          </strong>
        </li>
      </ul>
    </article>
  </section>

 

  <order-tracker
    [orderDataDetials]="orderDataDetialsTracking"
    [currentStatus]="orderDataDetials?.deliveryStatus"
  ></order-tracker>

 

  <star-rating
    *ngIf="feedBackData"
    [feedBackData]="feedBackData"
    [isFeedbackDataSubmited]="isFeedbackDataSubmited"
    (submitFeedBack)="submitFeedBack($event)"
  ></star-rating>

 

  <div class="order-view-footer">
    <button class="footer-btn ghost" routerLink="/customer-order-history">
      <i class="fa fa-arrow-left mr-1"></i>
      Back to Orders
    </button>
    <button
      class="footer-btn primary"
      *ngIf="loggedInUserType == 'CUSTOMER'"
      routerLink="/home"
    >
      Continue Shopping
    </button>
    <button
      class="footer-btn primary"
      *ngIf="loggedInUserType == 'RETAILER'"
      routerLink="/retailer-home"
    >
      Continue Shopping
    </button>
  </div>
</div>